import React, { useState, useEffect, useRef } from 'react'; // Added useRef
import emailjs from '@emailjs/browser'; // Import the library
import './App.css';

function App() {
  // State to control popup visibility
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSending, setIsSending] = useState(false); // New state for loading
  const form = useRef(); // Create a reference to the form

  useEffect(() => {
    document.title = "Test Technologies";
  }, []);

  const company = {
    name: "Test Technologies Ltd",
    email: "info@test-technologies.com",
    address: "32 Central Road Gloucester GL1 5BY"
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setIsSending(false); // Reset if they close/reopen
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true); // Start loading

    // Replace these strings with your actual IDs from EmailJS
    const SERVICE_ID = "service_ryi2jzw";
    const TEMPLATE_ID = "template_b0kkk2b";
    const PUBLIC_KEY = "AM8AoSse96JKoZC07";

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          alert("Message sent successfully!");
          setIsModalOpen(false); // Close the popup
      }, (error) => {
          alert("Failed to send message: " + error.text);
          })
      .finally(() => {
          setIsSending(false); // Stop loading regardless of success/fail
      });
  };

  return (
    <div>
      <nav className="navbar">
        <div className="logo">{company.name}</div>
        <div className="nav-links">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          {/* Button triggers the popup */}
          <button onClick={toggleModal} className="btn-contact-nav">Contact Us</button>
        </div>
      </nav>

      <header className="hero">
        <h2>Electronic Test Solutions</h2>
        <p>Helping your business test hardware and software.</p>
      </header>

{/* Popup Modal Logic */}
{isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={toggleModal}>&times;</button>
            <h3>Contact Test Technologies</h3>
            
            {/* Form now has a 'ref' and 'onSubmit' handler */}
            <form className="contact-form" ref={form} onSubmit={sendEmail}>
              <input type="text" name="name" placeholder="Your Name" required />
              <input type="email" name="email" placeholder="Your Email" required />
              <textarea name="message" placeholder="How can we help?" rows="4" required></textarea>
             {/* Button changes based on state */}
              <button type="submit" className="submit-btn" disabled={isSending}>
                {isSending ? <div className="spinner"></div> : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      )}

      <section id="about" style={{padding: '60px 10%'}}>
        <h3>About Us</h3>
  <p>Test Technologies was formed in 1993. The primary goal was to provide companies with electronic test methods and equipment. We initially provided services to the aviation industry. We have since moved into automotive,  industrial and manufacturing test areas.</p>
  <p>During our many years of being in the electronic test business, we gained much experience designing and building test systems. This has enabled us to provide products which are useful for automating the testing of electronic components and systems.</p>
  <p>We would be very glad to help you with any electronic test requirements you may have. We welcome any size project from a simple manually operated test box to a fully automated test system. Or maybe you just require a software solution.</p>
  <p>So please, just give a call to find out more.</p>
      </section>

      <section id="services" className="services">
        <h3 style={{textAlign: 'center', fontSize: '2rem'}}>Our Expertise</h3>
        <div className="grid">
          <div className="card">
            <h4>Test Requirements</h4>
            <p>Create detailed and effective test plans tailored to your needs.</p>
          </div>
          <div className="card">
            <h4>Hardware</h4>
            <p>Design mechanical and electronic hardware solutions.</p>
          </div>
          <div className="card">
            <h4>Software</h4>
            <p>Design and implement software solutions.</p>
          </div>
          <div className="card">
            <h4>Consulting</h4>
            <p>Expert advice for your next big project.</p>
          </div>
        </div>
      </section>

      <footer>
        <div>
          <h4>{company.name}</h4>
          <p>{company.address}</p>
        </div>
        <div>
          <p>Contact: {company.email}</p>
          <p>© 2026 All Rights Reserved</p>
        </div>
      </footer>
    </div>
  );
}

export default App;